/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpdateRemoteSessionIssuerForm,
  UpdateRemoteSessionIssuerForm$Outbound,
  UpdateRemoteSessionIssuerForm$outboundSchema,
} from "../components/updateremotesessionissuerform.js";

export type UpdateRemoteSessionIssuerSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type UpdateRemoteSessionIssuerSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type UpdateRemoteSessionIssuerSecurity = {
  option1?: UpdateRemoteSessionIssuerSecurityOption1 | undefined;
  option2?: UpdateRemoteSessionIssuerSecurityOption2 | undefined;
};

export type UpdateRemoteSessionIssuerRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  updateRemoteSessionIssuerForm: UpdateRemoteSessionIssuerForm;
};

/** @internal */
export type UpdateRemoteSessionIssuerSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const UpdateRemoteSessionIssuerSecurityOption1$outboundSchema:
  z.ZodMiniType<
    UpdateRemoteSessionIssuerSecurityOption1$Outbound,
    UpdateRemoteSessionIssuerSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function updateRemoteSessionIssuerSecurityOption1ToJSON(
  updateRemoteSessionIssuerSecurityOption1:
    UpdateRemoteSessionIssuerSecurityOption1,
): string {
  return JSON.stringify(
    UpdateRemoteSessionIssuerSecurityOption1$outboundSchema.parse(
      updateRemoteSessionIssuerSecurityOption1,
    ),
  );
}

/** @internal */
export type UpdateRemoteSessionIssuerSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const UpdateRemoteSessionIssuerSecurityOption2$outboundSchema:
  z.ZodMiniType<
    UpdateRemoteSessionIssuerSecurityOption2$Outbound,
    UpdateRemoteSessionIssuerSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function updateRemoteSessionIssuerSecurityOption2ToJSON(
  updateRemoteSessionIssuerSecurityOption2:
    UpdateRemoteSessionIssuerSecurityOption2,
): string {
  return JSON.stringify(
    UpdateRemoteSessionIssuerSecurityOption2$outboundSchema.parse(
      updateRemoteSessionIssuerSecurityOption2,
    ),
  );
}

/** @internal */
export type UpdateRemoteSessionIssuerSecurity$Outbound = {
  Option1?: UpdateRemoteSessionIssuerSecurityOption1$Outbound | undefined;
  Option2?: UpdateRemoteSessionIssuerSecurityOption2$Outbound | undefined;
};

/** @internal */
export const UpdateRemoteSessionIssuerSecurity$outboundSchema: z.ZodMiniType<
  UpdateRemoteSessionIssuerSecurity$Outbound,
  UpdateRemoteSessionIssuerSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => UpdateRemoteSessionIssuerSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => UpdateRemoteSessionIssuerSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function updateRemoteSessionIssuerSecurityToJSON(
  updateRemoteSessionIssuerSecurity: UpdateRemoteSessionIssuerSecurity,
): string {
  return JSON.stringify(
    UpdateRemoteSessionIssuerSecurity$outboundSchema.parse(
      updateRemoteSessionIssuerSecurity,
    ),
  );
}

/** @internal */
export type UpdateRemoteSessionIssuerRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  UpdateRemoteSessionIssuerForm: UpdateRemoteSessionIssuerForm$Outbound;
};

/** @internal */
export const UpdateRemoteSessionIssuerRequest$outboundSchema: z.ZodMiniType<
  UpdateRemoteSessionIssuerRequest$Outbound,
  UpdateRemoteSessionIssuerRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    updateRemoteSessionIssuerForm: UpdateRemoteSessionIssuerForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      updateRemoteSessionIssuerForm: "UpdateRemoteSessionIssuerForm",
    });
  }),
);

export function updateRemoteSessionIssuerRequestToJSON(
  updateRemoteSessionIssuerRequest: UpdateRemoteSessionIssuerRequest,
): string {
  return JSON.stringify(
    UpdateRemoteSessionIssuerRequest$outboundSchema.parse(
      updateRemoteSessionIssuerRequest,
    ),
  );
}
